import React, { useState, useEffect, useContext } from 'react'
import Loadable from '@loadable/component'
import { useTheme } from 'emotion-theming'
import { isBrowser, isPastScrollYMark } from '@jelly/utils'
import { EmailSubscribeContext } from '../EmailSubscribeProvider'

const THRESHOLD = 0.2
const dontShowEmailCapture = (isVisible) => (!isBrowser() || sessionStorage.getItem('closedEmailModal')) && !isVisible

const LazyEmailSignUpFloaterBar = Loadable(() =>
	import(/* webpackChunkName: 'EmailSignup' */ './LazyEmailSignUpFloaterBar').then(
		({ LazyEmailSignUpFloaterBar, mobile = true }) => LazyEmailSignUpFloaterBar
	)
)

export const EmailSignUpFloaterBar = ({ source }) => {
	const { MATCH_MEDIA } = useTheme()
	const isWeb = isBrowser() && window.matchMedia(MATCH_MEDIA.M).matches

	const [isPastY, setScrollY] = useState(false)
	const [wasFormTriggered, setWasFormTriggered] = useState(false)
	const [modalView, setModalView] = useState(isWeb ? 'pulledUp' : 'peeking')

	const { isVisible, setIsVisible, isScrollListenerEnabled } = useContext(EmailSubscribeContext)

	useEffect(() => {
		setWasFormTriggered(isVisible)
		if (isVisible) {
			setModalView('pulledUp')
		}
	}, [isVisible])

	// monitor the user's scrolling. Once the Y-threshold is passed, trigger the form
	useEffect(() => {
		let unsubscribeCallback
		if (isScrollListenerEnabled) {
			// start observing scroll position relative to threshold
			unsubscribeCallback = isPastScrollYMark(THRESHOLD, setScrollY)

			// if we are past the threshold let's trigger
			if (isPastY && !wasFormTriggered) {
				setWasFormTriggered(true)
			}
		}
		return () => {
			unsubscribeCallback && unsubscribeCallback()
		}
	}, [wasFormTriggered, isPastY, setIsVisible, isScrollListenerEnabled])

	if (dontShowEmailCapture(isVisible)) {
		return null
	}

	const handleViewChange = (view = 'closed') => {
		setModalView(view)
		if (view === 'closed') {
			sessionStorage.setItem('closedEmailModal', true)
			setIsVisible(false)
		}
	}

	if (wasFormTriggered) {
		return (
			<LazyEmailSignUpFloaterBar
				isMobileView={!isWeb}
				handleViewChange={handleViewChange}
				modalView={modalView}
				source={source}
				wasFormTriggered={wasFormTriggered}
			/>
		)
	}
	return null
}
